<template>
  <div v-if="user">
    <el-form
      v-if="user.email"
      ref="editedUser"
      :model="passwordData"
      label-position="top"
    >
      <el-form-item label="当前密码">
        <el-input
          type="password"
          v-model="passwordData.current_password"
          autocomplete="off"
        ></el-input>
        <p v-if="user.wechat_connected" style="color:red">
          微信注册新用户请在此处输入您的邮箱地址
        </p>
      </el-form-item>
      <el-form-item label="新密码" prop="pass">
        <el-input
          type="password"
          v-model="passwordData.password"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="确认新密码" prop="checkPass">
        <el-input
          type="password"
          v-model="passwordData.password_confirmation"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button class="float-right" @click="update">修改</el-button>
      </el-form-item>
    </el-form>
    <h3 class="text-center" v-else>请先前往"个人资料"添加邮箱地址</h3>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      passwordData: {
        current_password: "",
        password: "",
        password_confirmation: ""
      }
    };
  },
  computed: {
    ...mapState(["user", "token"])
  },
  methods: {
    update: function() {
      this.$http
        .post("/password/", this.passwordData)
        .then(() => {
          this.$message({
            type: "success",
            showClose: true,
            message: "密码修改成功"
          });
        })
        .catch(res => {
          if (res.statusCode() === 400) {
            this.$message({
              showClose: true,
              type: "error",
              message: res.data
            });
          } else {
            this.$message({
              showClose: true,
              type: "error",
              message: "密码修改失败"
            });
          }
        });
    },
    userImport: function() {
      this.$router.push("/import");
    }
  }
};
</script>
